import { errorString, Encoders, sendJson } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Help_NeuesTicket, Help_sizeLimitMB, Help_KundenportalTicketKategorie_$reflection, Help_UserTicketListItem_$reflection, Help_NeuesTicket_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { removeAt, item as item_1, tryFindIndex, length, map, sumBy, ofArray, empty, append, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { class_type, list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { UploadResult_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { Msg, Model, Model_Init, ResultText } from "./Types.fs.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { errorCmd, request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { FormField__get_IsValid, update } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { Remote$1, GlobalMsg, GlobalMessageBox_Error_Z721C83C5 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { some, value as value_2 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export function Http_postNeuesTicket(ticket) {
    return sendJson("/api/ticket/tokontakt", toString(0, Auto_generateBoxedEncoder_437914C6(Help_NeuesTicket_$reflection(), undefined, undefined, undefined)(ticket)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_getUserTicketList(onlyMyTickets) {
    const response = fetch(toText(printf("api/ticket/usertickets/%b"))(onlyMyTickets), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Help_UserTicketListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postAttachment(file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = fetch("/api/ticket/attachments/", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [((Item) => (new Types_HttpRequestHeaders(11, [Item])))("multipart/form-data")]), new Types_RequestProperties(2, [formData])])), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(UploadResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_deleteAttachment(fileId) {
    const response = fetch(`/api/ticket/attachments/${fileId}`, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), singleton(new Types_RequestProperties(0, ["DELETE"]))), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(class_type("System.Guid"), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_markAsRead(ticketId) {
    return sendJson("/api/ticket/markAsRead", toString(0, Auto_generateBoxedEncoder_437914C6(class_type("System.Guid"), undefined, undefined, undefined)(ticketId)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_getKundenportalTicketKategories() {
    const response = fetch("/api/ticket/kategorien", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Help_KundenportalTicketKategorie_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

function State_resultToResultText(result) {
    if (result.tag === 1) {
        if (result.fields[0].message.indexOf("429") === 0) {
            return new ResultText(1, []);
        }
        else if (result.fields[0].message.indexOf("413") === 0) {
            return new ResultText(2, []);
        }
        else {
            return new ResultText(3, []);
        }
    }
    else {
        return new ResultText(0, []);
    }
}

export function State_init(page, user, lastModel) {
    let model_1;
    if (user == null) {
        model_1 = Model_Init("", "", "", undefined, undefined);
    }
    else {
        switch (page.tag) {
            case 1: {
                const user_2 = user;
                model_1 = Model_Init(user_2.Name, user_2.Email, "", undefined, page.fields[0]);
                break;
            }
            case 2: {
                const user_3 = user;
                const model = Model_Init(user_3.Name, user_3.Email, "", undefined, page.fields[0]);
                model_1 = (new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, false, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow));
                break;
            }
            case 3: {
                const user_4 = user;
                model_1 = Model_Init(user_4.Name, user_4.Email, page.fields[0], page.fields[1], undefined);
                break;
            }
            default: {
                const user_1 = user;
                model_1 = Model_Init(user_1.Name, user_1.Email, "", undefined, undefined);
            }
        }
    }
    return [model_1, Cmd_batch(ofArray([singleton((dispatch) => {
        dispatch(new Msg(0, [model_1.ShowOnlyMyTickets]));
    }), singleton((dispatch_1) => {
        dispatch_1(new Msg(12, []));
    })]))];
}

export function State_update(msg, model) {
    let msg_1, msg_2;
    switch (msg.tag) {
        case 1:
            return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, Loaded(msg.fields[0]), model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), Cmd_none()];
        case 2:
            return [new Model(model.Name, model.Mail, update(model.Betreff, msg.fields[0]), model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), Cmd_none()];
        case 3:
            return [new Model(model.Name, model.Mail, model.Betreff, update(model.Text, msg.fields[0]), model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), Cmd_none()];
        case 6:
            if ((model.CurrentUploadSizeSum + sumBy((f) => f.size, msg.fields[0], {
                GetZero: () => 0,
                Add: (x, y) => (x + y),
            })) > ((Help_sizeLimitMB * 1024) * 1024)) {
                return [model, (msg_1 = (new Msg(15, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(`Ticketanhänge dürfen insgesamt maximal ${Help_sizeLimitMB} MB groß sein.`)])])), singleton((dispatch) => {
                    dispatch(msg_1);
                }))];
            }
            else {
                const cmd_1 = Cmd_batch(map((f_1) => request(Http_postAttachment, f_1, (Item_1) => (new Msg(7, [Item_1]))), msg.fields[0]));
                return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount + length(msg.fields[0]), model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), cmd_1];
            }
        case 7:
            if (msg.fields[0].tag === 1) {
                const model$0027_1 = new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount - 1, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow);
                if (msg.fields[0].fields[0].message.indexOf("415") === 0) {
                    return [model$0027_1, (msg_2 = (new Msg(15, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Für Ticketanhänge sind nur pdf-, jpg-, jpeg- und png-Dateien zulässig.")])])), singleton((dispatch_1) => {
                        dispatch_1(msg_2);
                    }))];
                }
                else {
                    return [model$0027_1, errorCmd((Item_2) => (new Msg(15, [Item_2])), "Upload", msg.fields[0].fields[0])];
                }
            }
            else {
                return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount - 1, model.Uploading, append(model.CurrentUploadList, singleton(msg.fields[0].fields[0])), model.CurrentUploadSizeSum + msg.fields[0].fields[0].Size, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), Cmd_none()];
            }
        case 8:
            return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, true, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), request(Http_deleteAttachment, msg.fields[0].Id, (Item_3) => (new Msg(9, [Item_3])))];
        case 9:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, false, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), errorCmd((Item_4) => (new Msg(15, [Item_4])), "Löschen", msg.fields[0].fields[0])];
            }
            else {
                let patternInput;
                const _arg = tryFindIndex((f_2) => (f_2.Id === msg.fields[0].fields[0]), model.CurrentUploadList);
                if (_arg == null) {
                    patternInput = [model.CurrentUploadList, model.CurrentUploadSizeSum];
                }
                else {
                    const i = _arg | 0;
                    const deleted = item_1(i, model.CurrentUploadList);
                    patternInput = [removeAt(i, model.CurrentUploadList), model.CurrentUploadSizeSum - deleted.Size];
                }
                return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, false, model.SendingResult, model.CurrentUploadCount, model.Uploading, patternInput[0], patternInput[1], model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), Cmd_none()];
            }
        case 4: {
            const ids = map((f_3) => f_3.Id, model.CurrentUploadList);
            const model_1 = new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, (model.SelectedKundenportalTicketKategorie != null) ? update(model.SelectedKundenportalTicketKategorieFormField, int32ToString(value_2(model.SelectedKundenportalTicketKategorie).Id)) : update(model.SelectedKundenportalTicketKategorieFormField, ""), model.TicketToShow);
            const isTicketKategorieValid = FormField__get_IsValid(model_1.SelectedKundenportalTicketKategorieFormField);
            const matchValue = model_1.SelectedKundenportalTicketKategorie;
            let matchResult, kategorie;
            if (matchValue != null) {
                if (isTicketKategorieValid) {
                    matchResult = 0;
                    kategorie = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [new Model(model_1.Name, model_1.Mail, model_1.Betreff, model_1.Text, model_1.RechnungId, true, model_1.SendingResult, model_1.CurrentUploadCount, model_1.Uploading, model_1.CurrentUploadList, model_1.CurrentUploadSizeSum, model_1.ShowOnlyMyTickets, model_1.UserTickets, model_1.KundenportalTicketKategorien, model_1.SelectedKundenportalTicketKategorie, model_1.SelectedKundenportalTicketKategorieFormField, model_1.TicketToShow), request(Http_postNeuesTicket, new Help_NeuesTicket(model_1.Betreff.Value, model_1.Text.Value, ids, model_1.RechnungId, kategorie.Id), (Item_5) => (new Msg(5, [Item_5])))];
                default:
                    return [model_1, Cmd_none()];
            }
        }
        case 5:
            return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, false, State_resultToResultText(msg.fields[0]), model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), singleton((dispatch_2) => {
                dispatch_2(new Msg(0, [model.ShowOnlyMyTickets]));
            })];
        case 10:
            return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, undefined), request(Http_markAsRead, msg.fields[0], (Item_6) => (new Msg(11, [Item_6])))];
        case 11:
            return [model, Cmd_none()];
        case 15:
            return [model, Cmd_none()];
        case 12:
            return [model, request(Http_getKundenportalTicketKategories, undefined, (Item_7) => (new Msg(13, [Item_7])))];
        case 13:
            if (msg.fields[0].tag === 0) {
                return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, msg.fields[0].fields[0], model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), Cmd_none()];
            }
            else {
                console.error(some("Die Ticketkategorien konnten nicht geladen werden"));
                return [model, Cmd_none()];
            }
        case 14:
            return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, model.ShowOnlyMyTickets, model.UserTickets, model.KundenportalTicketKategorien, msg.fields[0], update(model.SelectedKundenportalTicketKategorieFormField, int32ToString(value_2(msg.fields[0]).Id)), model.TicketToShow), Cmd_none()];
        default:
            return [new Model(model.Name, model.Mail, model.Betreff, model.Text, model.RechnungId, model.Sending, model.SendingResult, model.CurrentUploadCount, model.Uploading, model.CurrentUploadList, model.CurrentUploadSizeSum, msg.fields[0], new Remote$1(1, []), model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, model.SelectedKundenportalTicketKategorieFormField, model.TicketToShow), request(Http_getUserTicketList, msg.fields[0], (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
